<template>
    <rkm-form ref="Form">
        <box-unidade :data="{ form, model }" />
        <box-unidade-solicitante :data="{ form, model }" />
        <box-cotas :data="{ form, model }" />
        <box-faturamento class="mt-3" :data="{ form, model }" />
        <box-faturamento-laboratorio class="mt-3" :data="{ form, model }" />
        <box-protocolo :data="{ form, model }" />
        <box-motivo class="mt-3" :data="{ form, model }" />
        <box-supervisor class="mt-3" :data="{ form, model }" />
        <box-assinatura class="mt-3" :data="{ form, model }" />
        <box-impressao-agendamento class="mt-3" :data="{ form, model }" />
        <box-reagendar-exame class="mt-3" :data="{ form, model }" />
        <box-exame-ambulatorio-atendimento class="mt-3" :data="{ form, model }" />
        <box-web-service class="mt-3" :data="{ form, model }" />
        <box-integracao-aplicativo class="mt-3" :data="{ form, model }" />
        <box-classificacao-cadastro
            v-if="model.classificacaoCadastro"
            class="mt-3"
            :data="{ form, model }"
        />
    </rkm-form>
</template>

<script>
// Components.
import BoxUnidade from './components/unidade/Index'
import BoxUnidadeSolicitante from './components/unidade-solicitante/Index'
import BoxCotas from './components/cotas/Index'
import BoxProtocolo from './components/mensagem-protocolo/Index'
import BoxMotivo from './components/motivo/Index'
import BoxSupervisor from './components/supervisor/Index'
import BoxFaturamento from './components/faturamento/Index'
import BoxFaturamentoLaboratorio from './components/faturamento-laboratorio/Index'
import BoxAssinatura from './components/assinatura-eletronica/Index'
import BoxImpressaoAgendamento from './components/impressao-agendamento/Index'
import BoxReagendarExame from './components/reagendar-exame/Index'
import BoxExameAmbulatorioAtendimento from './components/exame-ambulatorio-atendimento/Index'
import BoxWebService from './components/webservice/Index'
import BoxIntegracaoAplicativo from './components/integracao-aplicativo/Form'
import BoxClassificacaoCadastro from './components/classificacao-cadastro/Index'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    components: { BoxUnidade, BoxUnidadeSolicitante, BoxCotas, BoxProtocolo, BoxMotivo, BoxSupervisor,
        BoxFaturamento, BoxFaturamentoLaboratorio, BoxAssinatura, BoxImpressaoAgendamento, BoxReagendarExame,
        BoxExameAmbulatorioAtendimento, BoxWebService, BoxIntegracaoAplicativo, BoxClassificacaoCadastro },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        form: {
            unidades: {}
        },
        model: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

             this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(({ data }) => {

                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const unidades = this.model.unidades.map(unidadeSolicitante => ({
                unidadeId: unidadeSolicitante.unidadeId,
                infraestruturaId: unidadeSolicitante.infraestruturaId,
                unidadeColeta: unidadeSolicitante.unidadeColeta,
                laboratorio: unidadeSolicitante.laboratorio,
                unidadeColetaSolicitante: unidadeSolicitante.unidadeColetaSolicitante,
                laboratorioPadraoInfraestruturaId: unidadeSolicitante.laboratorioPadraoInfraestruturaId,
            }))

            const unidadesSolicitantes = this.model.unidadesSolicitantes.map(unidadeSolicitante => ({
                unidadeId: unidadeSolicitante.unidadeId,
                infraestruturaId: unidadeSolicitante.infraestruturaId,
                urgencia: unidadeSolicitante.urgencia,
                alterado: unidadeSolicitante.alterado,
                exames: unidadeSolicitante.exames,
            }))

            const cotasUnidadeSolicitante = this.model.cotasUnidadeSolicitante.map(cotas => ({
                unidadeId: cotas.unidadeId,
                unidadeTipoId: cotas.unidadeTipoId,
                infraestruturaId: cotas.infraestruturaId,
                cotaUnidadeSolicitante: cotas.cotaUnidadeSolicitante,
            }))

            const cotasLaboratorio = this.model.cotasLaboratorio.map(cotas => ({
                unidadeId: cotas.unidadeId,
                unidadeTipoId: cotas.unidadeTipoId,
                infraestruturaId: cotas.infraestruturaId,
                cotaLaboratorio: cotas.cotaLaboratorio,
                alterado: cotas.alterado
            }))

            const cotasTransferencia = this.model.cotasTransferencia.map(cotas => ({
                id: cotas.id,
                laboratorioUnidadeId: cotas.laboratorioUnidadeId,
                laboratorioInfraestruturaId: cotas.laboratorioInfraestruturaId,
                origemUnidadeId: cotas.origemUnidadeId,
                origemInfraestruturaId: cotas.origemInfraestruturaId,
                unidadeTipoId: cotas.unidadeTipoId,
                destino: cotas.destino,
            }))

            const cotasExamePeriodo = this.model.cotasExamePeriodo.map(cotasExamePeriodo => ({
                id: cotasExamePeriodo.id,
                cotaTipoId: cotasExamePeriodo.cotaTipoId,
                periodo: cotasExamePeriodo.periodo,
                unidadeId: cotasExamePeriodo.unidadeId,
                infraestruturaId: cotasExamePeriodo.infraestruturaId,
                exames: cotasExamePeriodo.exames,
                alterado: cotasExamePeriodo.alterado,
            }))

            const mensagemProtocolo = this.model.mensagemProtocolo

            const motivos = this.model.motivo.map(motivo => ({
                id: motivo.id,
                descricao: motivo.descricao,
            }))

            const supervisores = this.model.supervisores.map(supervisor => ({
                usuarioId: supervisor.usuarioId
            }))

            const unidadesFaturamento = this.model.unidadesFaturamento.map(unidade => ({
                unidadeId: unidade.unidadeId,
                infraestruturaId: unidade.infraestruturaId,
                faturamentoRelacionado: unidade.faturamentoRelacionado,
                profissionais: unidade.profissionais,
                alterado: unidade.alterado,
            }))

            const laboratoriosFaturamento = this.model.laboratoriosFaturamento.map(unidade => ({
                unidadeId: unidade.unidadeId,
                infraestruturaId: unidade.infraestruturaId,
                faturamentoRelacionado: unidade.faturamentoRelacionado,
                profissionais: unidade.profissionais,
                alterado: unidade.alterado,
            }))

            const profissionaisAssinatura = this.model.profissionaisAssinatura.map(profissional => ({
                id: profissional.id,
                infraestruturaId: profissional.infraestruturaId,
                usuarioId: profissional.usuarioId,
                unidadeId: profissional.unidadeId,
            }))

            const impressaoAgendamentoTipoId = this.model.impressaoAgendamentoTipoId
            const webserviceTipoId = this.model.webserviceTipoId
            const exibirReagendarExame = this.model.exibirReagendarExame
            const exibirExameAmbulatorioAtendimento = this.model.exibirExameAmbulatorioAtendimento
            const integracaoAplicativo = this.model.integracaoAplicativo
            const classificacaoCadastro = this.model.classificacaoCadastro

            return this.camelObjectKeysToSnakeRecursive({
                unidades, unidadesSolicitantes, cotasUnidadeSolicitante, cotasLaboratorio, cotasTransferencia, cotasExamePeriodo,
                    mensagemProtocolo, motivos, supervisores, unidadesFaturamento, laboratoriosFaturamento, profissionaisAssinatura,
                    impressaoAgendamentoTipoId, webserviceTipoId, exibirReagendarExame, exibirExameAmbulatorioAtendimento,
                    integracaoAplicativo, classificacaoCadastro
            })
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        id: { type: Number }
    },
}
</script>